import React from 'react';
import { Tooltip } from 'reactstrap';

const ESGMaturityTooltip = ({ id, text, children }) => {
    const [tooltipOpen, setTooltipOpen] = React.useState(false);

    return (
        <span className="d-inline-block position-relative" style={{ cursor: 'pointer' }}>
            <span 
                id={id}
                onMouseEnter={() => setTooltipOpen(true)}
                onMouseLeave={() => setTooltipOpen(false)}
                onClick={() => setTooltipOpen(!tooltipOpen)}
                className="text-decoration-dotted"
            >
                {children}
            </span>
            <Tooltip
                isOpen={tooltipOpen}
                target={id}
                toggle={() => setTooltipOpen(!tooltipOpen)}
                placement="top"
                style={{
                    backgroundColor: '#333',
                    color: 'white',
                    padding: '8px 12px',
                    borderRadius: '4px',
                    fontSize: '14px',
                    maxWidth: '300px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                    zIndex: 1000
                }}
            >
                {text}
            </Tooltip>
        </span>
    );
};

export default ESGMaturityTooltip; 